import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  selectPeriod(event) {
    event.preventDefault();
    const period = event.currentTarget.dataset.period;

    // Update button states
    this.updateButtonStates(period);

    // Make turbo request to update widget content
    this.updateWidgetContent(period);
  }

  updateButtonStates(selectedPeriod) {
    // Remove primary class from all buttons
    this.element.querySelectorAll('[data-action*="selectPeriod"]').forEach(button => {
      button.classList.remove('bg-primary', 'text-white');
      button.classList.add('bg-transparent', 'text-neutral-700', 'hover:bg-neutral-200');
    });

    // Add primary class to selected button
    const selectedButton = this.element.querySelector(`[data-period="${selectedPeriod}"]`);
    if (selectedButton) {
      selectedButton.classList.remove('bg-transparent', 'text-neutral-700', 'hover:bg-neutral-200');
      selectedButton.classList.add('bg-primary', 'text-white');
    }
  }

  async updateWidgetContent(period) {
    try {
      const response = await fetch(`/dashboard/market_reference_rates_widget?period=${period}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html',
          'Turbo-Frame': 'market-reference-rates-widget'
        }
      });

      if (response.ok) {
        const html = await response.text();
        this.contentTarget.innerHTML = html;

        // Re-initialize any chart functionality if needed
        this.initializeCharts();
      } else {
        console.error('Failed to update widget content');
      }
    } catch (error) {
      console.error('Error updating widget content:', error);
    }
  }

  initializeCharts() {
    // Re-initialize any chart functionality after content update
    // This ensures charts work with the new period filter
    const chartButtons = this.contentTarget.querySelectorAll('[data-action*="openChartModal"]');
    chartButtons.forEach(button => {
      // Remove existing event listeners to prevent duplicates
      button.removeEventListener('click', this.openChartModal.bind(this));
      // Add new event listener
      button.addEventListener('click', (event) => {
        this.openChartModal(event);
      });
    });
  }

  openChartModal(event) {
    event.preventDefault();
    event.stopPropagation();

    const { label, dataset, column } = event.currentTarget.dataset;
    const modal = document.getElementById("market-data-chart-modal");

    if (modal) {
      const titleElement = modal.querySelector("h3");
      if (titleElement) {
        titleElement.textContent = label;
      }

      modal.classList.remove("hidden");
      modal.setAttribute("aria-hidden", "false");

      const params = new URLSearchParams({
        label,
        dataset,
        column,
        period: this.getCurrentPeriod()
      });

      const frame = document.getElementById("market-data-chart-frame");
      if (frame) {
        frame.src = `/dashboard/market_data_line?${params.toString()}`;
      }
    }
  }

  closeChartModal() {
    const modal = document.getElementById("market-data-chart-modal");
    if (modal) {
      modal.classList.add("hidden");
      modal.setAttribute("aria-hidden", "true");

      // Clear the chart container
      const container = document.getElementById("marketDataGraphContainer");
      if (container) {
        container.innerHTML = "";
      }
    }
  }

  getCurrentPeriod() {
    const activeButton = this.element.querySelector('[data-action*="selectPeriod"].bg-primary');
    return activeButton ? activeButton.dataset.period : 'year';
  }
}
